// extracted by mini-css-extract-plugin
module.exports = {"highlightsFiltersRoot":"aPLvBUh2","header":"DyD0YCWE","labelWrapper":"BppetTWD","toggle":"C3ChR_xp","label":"viY7LmYu"};